// Storage utility to handle token persistence
// Using localStorage for persistent storage across browser sessions

const STORAGE_KEYS = {
  TOKEN: 'token',
  USERNAME: 'username',
  EMAIL: 'email',
  ID: 'id',
  FULL_NAME: 'fullName',
  ROLE: 'role'
};

// Use localStorage for persistent storage across browser sessions
const storage = {
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Error setting localStorage item:', error);
      // Fallback to sessionStorage if localStorage is not available
      sessionStorage.setItem(key, value);
    }
  },
  
  getItem: (key) => {
    try {
      return localStorage.getItem(key) || sessionStorage.getItem(key);
    } catch (error) {
      console.error('Error getting storage item:', error);
      return sessionStorage.getItem(key);
    }
  },
  
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing storage item:', error);
    }
  },
  
  clear: () => {
    try {
      // Clear auth-related items from both storages
      Object.values(STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  }
};

// Helper functions for auth data
export const authStorage = {
  setAuthData: (data) => {
    storage.setItem(STORAGE_KEYS.TOKEN, data.token);
    storage.setItem(STORAGE_KEYS.USERNAME, data.username);
    storage.setItem(STORAGE_KEYS.EMAIL, data.email || `${data.username}@council4.org`);
    storage.setItem(STORAGE_KEYS.ID, data.id);
    storage.setItem(STORAGE_KEYS.FULL_NAME, data.fullName || '');
    storage.setItem(STORAGE_KEYS.ROLE, data.role || 'User');
  },
  
  getToken: () => storage.getItem(STORAGE_KEYS.TOKEN),
  getUsername: () => storage.getItem(STORAGE_KEYS.USERNAME),
  getEmail: () => storage.getItem(STORAGE_KEYS.EMAIL),
  getId: () => storage.getItem(STORAGE_KEYS.ID),
  getFullName: () => storage.getItem(STORAGE_KEYS.FULL_NAME),
  getRole: () => storage.getItem(STORAGE_KEYS.ROLE),
  
  clearAuthData: () => storage.clear()
};

export default storage;